import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'
import breakPoints from 'themes/breakPoints'
import Item from './item'

const Section = styled.section`
  background: #fafbfb;
  @media (max-width: ${breakPoints.md.max}px) {
    padding: 48px 0;
  }
`

const About = ({ data }) => {
  // console.log(data)
  return (
    <Section>
      <Container>
        <Row>
          {data.map((item, index) => (
            <Col xs={12} lg={6}>
              <Item key={index} {...item} />
            </Col>
          ))}
        </Row>
      </Container>
    </Section>
  )
}

export default About
